import { prop } from 'ramda'

export const getFullName = object => {
  if (object) {
    return `${prop('firstName', object)} ${prop('lastName', object)}`
  }

  return null
}
